import { useAppContext } from '../../../../app/Context';
import { usePollContext } from '../../Context';
import { getIsPollPublished } from '../helpers';

const useFooter = () => {
  const { isPresenting } = useAppContext();

  const { poll } = usePollContext();

  const isPollPublished = getIsPollPublished(poll);

  return { isPollPublished, isPresenting };
};

export default useFooter;
